import { render, staticRenderFns } from "./Landmark.vue?vue&type=template&id=df80a760&scoped=true"
import script from "./Landmark.vue?vue&type=script&lang=js"
export * from "./Landmark.vue?vue&type=script&lang=js"
import style0 from "./Landmark.vue?vue&type=style&index=0&id=df80a760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df80a760",
  null
  
)

export default component.exports